var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.023,
    height: 20,
    viewBox: "0 0 26.023 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    d: "M42.65,76.479c-1.268-1.17-3.316-3.316-4.681-4.681-1.365-1.268-2.243-.2-3.9,1.56-1.853,1.853,0,2.828,2.633,5.461L41.479,83.6c1.755,1.56,3.218-.78,5.559-3.023l9.557-9.654c3.023-2.926,3.706-2.926,1.268-5.266-2.145-2.243-2.048-2.243-5.461,1.268C50.841,68.385,43.137,76.186,42.65,76.479Z",
    transform: "translate(-33.319 -64.104)",
    fill: "#e83198",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWins);
export default __webpack_public_path__ + "static/media/wins.62d8e9aba507fa3f9a2e4ef1d4bc5340.svg";
export { ForwardRef as ReactComponent };